import {CreateInstance} from './config'
const dash = CreateInstance('dash')
const chart = CreateInstance('chart')
const history = CreateInstance('history')
const excel = CreateInstance('export/excel')
export default {dash, chart, history, excel}
export {dash, chart, history, excel}
